import { api } from "@/lib/api";

export const qcApi = {
  meta: () => api.get("/qc/meta").then((r) => r.data),
  stats: () => api.get("/qc/stats").then((r) => r.data),
  inbox: () => api.get("/qc/inbox").then((r) => r.data),
  receive: (batch_ids) => api.post("/qc/receive", { batch_ids }).then((r) => r.data),
  inspections: (params) => api.get("/qc/inspections", { params }).then((r) => r.data),
  inspection: (id) => api.get(`/qc/inspections/${id}`).then((r) => r.data),
  update: (id, body) => api.put(`/qc/inspections/${id}`, body).then((r) => r.data),
  setStatus: (id, status, note) => api.patch(`/qc/inspections/${id}/status`, { status, note }).then((r) => r.data),
  passed: () => api.get("/qc/passed").then((r) => r.data),
  rework: () => api.get("/qc/rework").then((r) => r.data),
};

export const QC_STATUS_STYLE = {
  "Pending Inspection": "bg-slate-100 text-slate-700",
  "Under Inspection": "bg-blue-50 text-blue-700 border border-blue-200",
  Passed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  "Passed with Remarks": "bg-teal-50 text-teal-700 border border-teal-200",
  Rejected: "bg-rose-50 text-rose-700 border border-rose-200",
  "Rework Required": "bg-amber-50 text-amber-700 border border-amber-200",
  "Re-Inspection": "bg-violet-50 text-violet-700 border border-violet-200",
  Closed: "bg-slate-200 text-slate-500",
};

export const GRADE_STYLE = {
  A: "bg-emerald-50 text-emerald-700",
  B: "bg-amber-50 text-amber-700",
  C: "bg-orange-50 text-orange-700",
};
